import { Button, Card, CardActions, CardContent, Grid, Link, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { IOccupation } from 'realhaus-sdk';

import { format } from 'date-fns';
import { DocumentViewerField } from '../document/documentViewField';

export const IncomeCard: React.FC<{
    occupation: IOccupation;
    onDelete?: (occupation: IOccupation) => void;
    onEdit?: (occupation: IOccupation) => void;
}> = observer(({ occupation, onDelete, onEdit }) => {
    return (
        <>
            <Card variant='outlined'>
                <CardContent>
                    <Grid container>
                        <Grid item xs={12} md={6} lg={4} spacing={2} paddingBottom={1}>
                            <Typography variant='subtitle2'>Dates</Typography>
                            <Typography variant='body2'>
                                {format(occupation.startDate || new Date(), 'MMM yyyy')}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4} spacing={2} paddingBottom={1}>
                            <Typography variant='subtitle2'>Title</Typography>
                            <Typography variant='body2'>{occupation.title}</Typography>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4} spacing={2} paddingBottom={1}>
                            <Typography variant='subtitle2'>Business Type</Typography>
                            <Typography variant='body2'>{occupation.businessType}</Typography>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4} spacing={2} paddingBottom={1}>
                            <Typography variant='subtitle2'>Employer</Typography>
                            <Typography variant='body2'>{occupation.employer}</Typography>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4} spacing={2} paddingBottom={1}>
                            <Typography variant='subtitle2'>Supervisor/Manager</Typography>
                            <Typography variant='body2'> {occupation.manager}</Typography>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4} spacing={2} paddingBottom={1}>
                            <Typography variant='subtitle2'>Status</Typography>
                            <Typography variant='body2'> {occupation.status}</Typography>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4} spacing={2} paddingBottom={1}>
                            <Typography variant='subtitle2'>Income</Typography>
                            <Typography variant='body2'>
                                ${occupation.income} /{occupation.incomeType}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4} spacing={2} paddingBottom={1}>
                            <Typography variant='subtitle2'>Proof of Occupation</Typography>

                            <DocumentViewerField
                                title={occupation.proofOfOccupation?.type || ''}
                                url={occupation.proofOfOccupation?.fileUrl || ''}
                            />
                        </Grid>
                    </Grid>
                </CardContent>

                <CardActions>
                    {!!onEdit && (
                        <Button
                            variant='outlined'
                            color='primary'
                            size='small'
                            onClick={() => onEdit(occupation)}
                        >
                            Edit
                        </Button>
                    )}
                    {!!onDelete && (
                        <Button
                            variant='text'
                            color='secondary'
                            size='small'
                            onClick={() => onDelete(occupation)}
                        >
                            Delete
                        </Button>
                    )}
                </CardActions>
            </Card>
        </>
    );
});
